import Vue from 'vue';
import ErrorBar from '@/vue/components/ErrorBar.vue';

const node = document.querySelector('#vue-error-bar');

new Vue({
    el: node,
    render: (h) => h(ErrorBar)
});
